<template>
    <Modal :is-show-close-menu="false" class="tiw__step__reasonsCancellation">
        <template #header>
            <p class="tiw__h2">
                {{ useTranslate("tiw__reasonsCancellation__title") }}
            </p>
            <p>{{ useTranslate("tiw__reasonsCancellation__description") }}</p>
        </template>

        <div class="tiw__step__reasonsCancellation__body">
            <template v-if="TIWStore.REASONS_TO_CANCEL.length">
                <div
                    v-for="{ name, rejectId } in TIWStore.REASONS_TO_CANCEL"
                    :key="rejectId"
                    class="tiw__step__reasonsCancellation__body__inputWrapper"
                >
                    <div class="tiw__step__reasonsCancellation__body__inputWrapper__radio">
                        <input
                            :id="name"
                            type="radio"
                            name="reasons"
                            @change="setChosenReason(rejectId)"
                        />
                        <span
                            class="tiw__step__reasonsCancellation__body__inputWrapper__radio__custom"
                        ></span>
                    </div>
                    <label :for="name">{{ name }}</label>
                </div>
            </template>
            <RadioSkeleton
                class="tiw__step__reasonsCancellation__body__skeletons"
                v-else
                :count="5"
            />
            <div
                v-if="chosenReason === 'other'"
                class="tiw__step__reasonsCancellation__body__textarea"
            >
                <textarea
                    id="reasons_textarea"
                    v-model="otherReason"
                    placeholder="Write your own reason for canceling"
                />
                <span class="tiw__step__reasonsCancellation__body__textarea__textHelper"
                    >max 100 symbols</span
                >
            </div>
            <div class="tiw__step__reasonsCancellation__body__actions">
                <Button
                    class="tiw__step__reasonsCancellation__body__actions__return"
                    variant="link"
                    color="link"
                    @click="onBack"
                >
                    {{ useTranslate("tiw__reasonsCancellation__button__return") }}
                </Button>
                <Button
                    :disabled="!chosenReason"
                    class="tiw__step__reasonsCancellation__body__actions__cancel"
                    color="cancel"
                    @click="onCancel"
                >
                    {{ useTranslate("tiw__reasonsCancellation__button__cancel") }}
                </Button>
            </div>
        </div>
    </Modal>
</template>

<script lang="ts">
export default {
    name: "ReasonsCancellation",
};
</script>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";

import apiGetBuyoutReject from "~/tiw/hooks/requests/apiGetBuyoutReject/apiGetBuyoutReject";
import apiSendBuyoutReject from "~/tiw/hooks/requests/apiSendBuyoutReject/apiSendBuyoutReject";
import useStoreResetter from "~/tiw/hooks/useStoreResetter/useStoreResetter";
import useTranslate from "~/tiw/hooks/useTranslate/useTranslate";
import { useHowYouRateDeviceStore } from "~/tiw/stores/howYouRateDevice/howYouRateDevice";
import { useTIWStore } from "~/tiw/stores/tiw/tiw";
import Button from "~/tiw/ui/button/button.vue";
import { RadioSkeleton } from "~/tiw/ui/skeletons";

import Modal from "../../modal/modal.vue";

const TIWStore = useTIWStore();
const howYouRateDeviceStore = useHowYouRateDeviceStore();
const chosenReason = ref<null | string>(null);
const otherReason = ref<null | string>(null);

const setChosenReason = (reasonId: string) => {
    chosenReason.value = reasonId;
};

const onGetReasons = async () => {
    const data = await apiGetBuyoutReject(TIWStore.WIDGET_DATA.token, TIWStore.standardizedLocale);
    TIWStore.REASONS_TO_CANCEL = data;
};

const onBack = () => {
    chosenReason.value = null;
    TIWStore.backToPrevStep();
};

const onCancel = async () => {
    await apiSendBuyoutReject(TIWStore.WIDGET_DATA.token, {
        status: "DECLINE_IN_POS",
        deviceId: howYouRateDeviceStore.registeringDeviceData?.deviceId ?? "",
        systemInfo: chosenReason.value,
        userComment: otherReason.value,
    });

    useStoreResetter();
    TIWStore.INJECTED_TIW.current_api.onDrop();
    TIWStore.switchStep("chooseDevice");
    TIWStore.closeWidget();
};

watch(chosenReason, () => {
    if (chosenReason.value !== "other") {
        otherReason.value = null;
    }
});

onMounted(() => {
    if (!TIWStore.REASONS_TO_CANCEL.length) onGetReasons();
});
</script>

<style lang="scss" src="./reasonsCancellation.scss"></style>
